import useSWR from "swr";


export const useFetchVisitHistory = (lineAccountId?: string) => {
  const fetcherKey = lineAccountId ? `external_api/line/accounts/${lineAccountId}/visit-history/` : null;
  const { data: visitHistory, error, isLoading } = useSWR<string[]>(fetcherKey)
  return { visitHistory, isLoading, error };
};
